import React from 'react';
import { connect } from 'react-redux';
import { OUTER_BORDERS_UNLOADED, OUTER_BORDERS_LOADED } from '../constants/actionTypes';
import Banner from './Home/Banner';
import { createItemList, importAllImagesFromFolder, mergeImageListWithThumbanilList, pretifyImageList } from './helpers';
import { SRLWrapper } from "simple-react-lightbox";
import { slrOptions } from '../constants/constants';
import Footer from './Home/Footer';

const mapStateToProps = state => ({
  ...state.home,
  appName: state.common.appName
});

const mapDispatchToProps = dispatch => ({  
  onLoad: () =>
    dispatch({ type: OUTER_BORDERS_LOADED }),
  onUnload: () =>
    dispatch({ type: OUTER_BORDERS_UNLOADED })
});

const rawTnList = importAllImagesFromFolder(require.context('../style/img/outerborders/thumbnails', false, /\.(png|jpe?g|svg)$/));
const pretteyTnList = pretifyImageList(rawTnList);

const rawFileList = importAllImagesFromFolder(require.context('../style/img/outerborders', false, /\.(png|jpe?g|svg)$/));
const pretteyFileList = pretifyImageList(rawFileList);

const imageList = mergeImageListWithThumbanilList(pretteyFileList, pretteyTnList);
const rows = createItemList(imageList);

class OuterBorders extends React.Component {
  render() {
    return (
      <SRLWrapper options={slrOptions}>
        <div className="home-page">
          <Banner
            appName={this.props.appName}
          />
          <div className="container page">
            {Object.keys(rows).map(row => {
              return (
                <div className="row" key={row}>
                  {rows[row].map(file => {
                    return (
                    <div class="col-md-4">
                      <a href={file.url} title={file.title} data-gallery="">
                        <span class="image-number">{file.title}</span>
                        <img src={file.thumbnailUrl} alt={file.title} class="img-thumbnail" />
                      </a>
                    </div>
                    )
                  })}
                </div>
              )
            })}            
          </div>
          <Footer />
        </div>
      </SRLWrapper>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(OuterBorders);


// WEBPACK FOOTER //
// ./src/components/OuterBorders.js